import React, { useState } from 'react';
import '../../Assets/CSS/Contacts.scss';
import '../../Assets/CSS/Home.scss';
import contactHeroBackground from '../../Assets/Images/Aboutus/17973903.jpg';
import bgImage from '../../Assets/Images/Aboutus/bg-3.jpg';
import axios from 'axios';
import "../../Assets/CSS/Styles.scss";



const ContactPage = () => {

  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    mobileNumber: '',
    instituteType: '',
    budgetRange: '',
    designation: '',
    institutionName: '',
    projectDetails: '',
    updatesOptIn: false
  });

  const [success, setSuccessMessage] = useState('');
  const [error, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const res = await axios.post('http://localhost:8000/api/contact', formData);
      if (res.status === 201 || res.status === 200) {
        setSuccessMessage('Form submitted successfully!');
        setFormData({
          fullName: '',
          emailAddress: '',
          mobileNumber: '',
          instituteType: '',
          budgetRange: '',
          designation: '',
          institutionName: '',
          projectDetails: '',
          updatesOptIn: false
        });
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="contact-page-container mt60">
      {/* Hero Section */}
      <div className="relative h-[500px] md:h-[488px] flex items-center justify-center p-2 overflow-hidden">
        <div
          className="absolute inset-0 bg-center bg-cover animate-slowZoom"
          style={{ backgroundImage: `url(${contactHeroBackground})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-[3px] z-10"></div>

        <div className="relative z-10 text-white text-center max-w-4xl space-y-7">
          <div className="animate-fadeSlideIn delay-100">
            <div className="inline-flex items-center px-3 py-1 mb-4 text-sm font-medium text-black bg-[#ffdd9d] rounded-full">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Ready to Transform Your Institution?
            </div>
          </div>
          <h1 className="font-heading font-bold-500 text-2xl md:text-4xl lg:text-5xl animate-fadeSlideIn delay-200">
            Let's Bring Your <span className="text-[#FBBF24]">Vision</span> to Life
          </h1>
          <p className="font-ui text-md leading-6 animate-fadeSlideIn delay-300">
            Reach out to us — we usually reply within 24 hours with a personalized
            <br />
            consultation tailored to your institution's unique needs.
          </p>
        </div>
      </div>

      {/* Contact Form */}
      <div className="contact-wrapper font-ui bg-[#F9FAFB]">
        <div className="contact-wrapper font-ui bg-[#F9FAFB]">
          <div className="flex justify-center py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-xl w-full bg-white p-8 md:p-10 rounded-lg shadow-xl border border-[#F59E0B]">
            
              <h2 className="contact-method-title font-heading">Ready to Transform Your Institution?</h2>
              <p className="contact-subtitle font-ui">
                Share your vision with us and Let's Build Something Extraordinary Together!
              </p>
                
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Full Name */}
                  <div>
                    <label htmlFor="fullName" className="contact-label block mb-2">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="fullName"
                      name="fullName"
                      type="text"
                      required
                      className="contact-input"
                      placeholder="Enter your full name"
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Email Address */}
                  <div>
                    <label htmlFor="emailAddress" className="contact-label block mb-2">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="emailAddress"
                      name="emailAddress"
                      type="email"
                      required
                      className="contact-input"
                      placeholder="your.email@example.com"
                      value={formData.emailAddress}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Mobile Number */}
                  <div>
                    <label htmlFor="mobileNumber" className="contact-label block mb-2">
                      Mobile Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="mobileNumber"
                      name="mobileNumber"
                      type="tel"
                      required
                      className="contact-input"
                      placeholder="Enter your mobile number"
                      value={formData.mobileNumber}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Institute Type */}
                  <div>
                    <label htmlFor="instituteType" className="contact-label block mb-2">
                      Institute Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="instituteType"
                      name="instituteType"
                      required
                      className="contact-select"
                      value={formData.instituteType}
                      onChange={handleChange}
                    >
                      <option value="">Select institute type</option>
                      <option value="school">Technical</option>
                      <option value="college">Medical</option>
                      <option value="university">Engineering</option>
                      <option value="training-center">Arts,Commerce,Science</option>
                      <option value="corporate">Corporate</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  {/* Budget Range */}
                  <div>
                    <label htmlFor="budgetRange" className="contact-label block mb-2">
                      Budget Range
                    </label>
                    <select
                      id="budgetRange"
                      name="budgetRange"
                      className="contact-select"
                      value={formData.budgetRange}
                      onChange={handleChange}
                    >
                      <option value="">Select budget range</option>
                      <option value="less-than-10k">Less than 10,0000</option>
                      <option value="10k-50k">10,0000 - 50,0000</option>
                      <option value="50k-100k">50,0000 - 100,0000</option>
                      <option value="more-than-100k">More than 100,0000</option>
                    </select>
                  </div>

                  {/* Role / Designation */}
                  <div>
                    <label htmlFor="designation" className="contact-label block mb-2">
                      Role / Designation <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="designation"
                      name="designation"
                      type="text"
                      required
                      className="contact-input"
                      placeholder="e.g. Principal, Director, Head of IT"
                      value={formData.designation}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Institution/Company Name */}
                  <div className="md:col-span-2">
                    <label htmlFor="institutionName" className="contact-label block mb-2">
                      Institution / Company Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="institutionName"
                      name="institutionName"
                      type="text"
                      required
                      className="contact-input w-full"
                      placeholder="Enter your organization name"
                      value={formData.institutionName}
                      onChange={handleChange}
                    />
                  </div>
                </div>


                {/* Project Details */}
                <div>
                  <label htmlFor="projectDetails" className="contact-label block mb-2">
                    Project Details <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="projectDetails"
                    name="projectDetails"
                    rows="4"
                    required
                    className="contact-textarea"
                    placeholder="Describe your project or goals..."
                    value={formData.projectDetails}
                    onChange={handleChange}
                  ></textarea>
                </div>

                {/* Checkbox */}
                <div className="flex items-start">
                  <input
                    type="checkbox"
                    id="updatesOptIn"
                    name="updatesOptIn"
                    className="mt-1"
                    checked={formData.updatesOptIn}
                    onChange={(e) =>
                      setFormData({ ...formData, updatesOptIn: e.target.checked })
                    }
                  />
                  <label htmlFor="updatesOptIn" className="ml-2 text-sm">
                    I'd like to receive updates about new features, case studies, and educational technology insights.
                  </label>
                </div>

                {/* Submit Button */}
                <button type="submit" className="contact-button font-ui">
                  Send Message
                </button>

                {/* Note */}
                <p className="contact-note">
                  We respect your privacy and will never share your information.
                </p>
              </form>
                        {success && <p className="text-green-600 text-center mb-4">{success}</p>}
              {error && <p className="text-red-600 mb-4">{error}</p>}
            </div>
          </div>
        </div>

        {/* Contact Info Section */}
        <section
          className="relative py-16 bg-cover bg-center bg-no-repeat overflow-hidden"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage:
              'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}
        >
          <div className="absolute inset-0 bg-white bg-opacity-70 z-0"></div>

          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="contact-method-title font-ui">Prefer a Different Way to Connect?</h2>
              <p className="subHeads font-ui text-[#4B5563]">
                Choose the communication method that works best for you
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {[
                {
                  title: 'Call Us',
                  desc: 'Speak directly with our experts',
                  icon: (
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  ),
                  link: (
                    <a
                      href="tel:+919876543210"
                      className="text-[#2B355A] font-semibold hover:underline mt-2 block"
                    >
                      +91 98765 43210
                    </a>
                  ),
                },
                {
                  title: 'Email Us',
                  desc: 'Send us a detailed message',
                  icon: (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-2 6V7a2 2 0 00-2-2H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-3"
                    />
                  ),
                  link: (
                    <a
                      href="mailto:sales@globalsolutions.com"
                      className="text-[#2B355A] font-semibold hover:underline mt-2 block"
                    >
                      sales@globalsolutions.com
                    </a>
                  ),
                },
                {
                  title: 'Visit Us',
                  desc:
                    'Global Solutions, Off. No. 118, Shree Ganesh Galaxy, Alandi Rd...',
                  icon: (
                    <>
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0L6.343 16.657a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </>
                  ),
                },
              ].map(({ title, desc, icon, link }, i) => (
                <div
                  key={i}
                  className="relative bg-white border-2 border-amber-500 rounded-xl shadow-sm p-6 pt-10 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  {/* Floating Icon */}
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                    <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                      <svg
                        className="h-8 w-8 text-amber-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        {icon}
                      </svg>
                    </div>
                  </div>

                  {/* Card Content */}
                  <div className="mt-10">
                    <h3 className="text-[20px] font-bold text-[#111827] mb-2">{title}</h3>
                    <p className="text-[15px] text-[#374151] font-ui mb-2">{desc}</p>
                    {link}
                  </div>
                </div>
              ))}
            </div>



            {/* Response Stats */}
            <div className="text-center mb-16">
              <h3 className="contact-method-title font-ui">Our Response Promise</h3>
              <p className="subHeads font-ui text-[#4B5563]">
                We typically respond to all inquiries within 24 hours. For urgent matters, please call us directly.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 contact-stat-title font-heading text-center">
              {[
                ['10+', 'Years Experience'],
                ['24hrs', 'Service Support'],
                ['99.9%', 'Uptime Guaranteed'],
                
                
              ].map(([stat, label], i) => (
                <div key={i} className="p-4 rounded-lg">
                  <h3
                    className="contact-stat-title animate-bounceTopToBottom"
                    style={{ animationDelay: `${i * 0.5}s` }}
                  >
                    {stat}
                  </h3>
                  <p className="contact-stat-sub">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
